export default __webpack_public_path__ + "static/media/mongodb.bfa6cdd8.svg";